import React, { useState, useEffect, useContext } from 'react'
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Form,
    InputGroup,
    Button
} from 'reactstrap'
import DatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import es from 'date-fns/locale/es'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { isEmpty } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import moment from 'moment'
import 'moment/min/locales'
import { withNamespaces } from 'react-i18next'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import user1 from '../../assets/images/users/avatar-1.jpg'
import ApiService from '../../data/services/ApiService'
import { updateAvatar, updateProfile } from '../../store/actions'
import { GeneralContext } from '../../context/'

registerLocale('es', es)
moment.locale('es')

const Index = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [user, setUser] = useState({
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        countryCode: '',
        phone: '',
        documentType: '',
        document: '',
        country: '',
        gender: '',
        dateOfBirth: '',
        password: ''
    })
    const [dateOfBirth, setDateOfBirth] = useState('')
    const [password, setPassword] = useState()
    const [confirmPassword, setConfirmPassword] = useState()

    const [countryCodes] = useState([
        {
            value: '+52',
            label: '+52 (MX)'
        },
        {
            value: '+1',
            label: '+1 (US)'
        },
    ])

    const [countries] = useState([
        'México',
        'Estados Unidos',
        'Canadá'
    ])

    const [documentTypes] = useState([
        'Pasaporte',
        'INE',
        'Licencia'
    ])

    const [genders] = useState([
        'Femenino',
        'Masculino'
    ])

    const [avatars, setAvatars] = useState([])

    const fetchAvatars = async () => {
        try {
            setLoading(true)
            const response = await ApiService.getAvatars()
            setAvatars(response.data.data)
            setLoading(false)
        } catch (e) {
            toastr.error(`${e.response.data.message}`, 'Error')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        (async function fetch() {
            await fetchAvatars()
        })()
        setUser(props.user)
        setDateOfBirth(!isEmpty(props.user.dateOfBirth) ? moment(props.user.dateOfBirth).toDate() : '')
    }, []) // eslint-disable-line

    const _handleFileUpload = (event) => {
        let files = event.target.files
        const types = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif']

        if (types.every(type => files[0].type !== type)) {
            toastr.error('Solo se aceptan imágenes', 'Error')

            return 
        }
        setLoading(true)
        fileUpload(files[0]).then((response) => {
            if (!response.data.success) {
                toastr.error('No pude actualizar tu avatar', 'Error')
                setLoading(false)
                return
            }

            setUser({
                ...user,
                avatar: response.data.fileURL
            })
            setLoading(false)
            props.updateAvatar(response.data.fileURL)
            toastr.success('Actualicé tu avatar', '¡Éxito!')
        }).catch(error => {
            console.log('fileUpload', error)
            setLoading(false)
            toastr.error('No pude actualizar tu avatar', 'Error')
        })
    }

    const fileUpload = (file) => {
        const formData = new FormData()

        formData.append('userId', user.id)
        formData.append('file', file)

        return ApiService.uploadUserAvatar(formData)
    }

    const _handleSubmit = async (e) => {
        e.preventDefault()
        user.dateOfBirth = dateOfBirth
        setLoading(true)
        const response = await ApiService.updateUser(user)

        if (!response) {
            toastr.error(`No pude actualizar tus datos`)
            setLoading(false)
            return
        }
        setLoading(false)
        props.updateProfile(user)
        toastr.success(`Actualicé tus datos`)
    }

    const _handleUdatePassword = async (e) => {
        e.preventDefault()

        if (password !== confirmPassword) {
            toastr.error(`Las contraseñas no coinciden`)

            return
        }
        setLoading(true)
        const response = await ApiService.updatePassword({
            userId: user.id,
            password
        })

        if (!response) {
            toastr.error(`No pude actualizar tu contraseña`)
            setLoading(false)
            return
        }
        setLoading(false)
        toastr.success(`Actualicé tu contraseña`)
    }

    const setAvatar = () => {
        if (!isEmpty(user)) {
            if (!isEmpty(user.avatar)) {
                return user.avatar
            }
            if (!isEmpty(user.avatarDefault)) {
                if (!isEmpty(user.avatarDefault.avatarUrl)) {
                    return user.avatarDefault.avatarUrl
                }
            }
        }
        return user1
    }

    const updateAvatar = async (e, item) => {
        try {
            e.preventDefault()
            setLoading(true)
            const response = await ApiService.updateAvatar(item)
            if (response.data.success) {
                setUser(response.data.data)
                props.updateAvatar(response.data.data.avatarDefault.avatarUrl)
                toastr.success(`Avatar actualizado.`)
            }
        } catch(e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title={props.t("Vendora")}
                        breadcrumbItem={`${user.firstName} ${user.lastName}`}
                        parentLink={`/perfil`}
                    />

                   <Row>
                        <Col sm={3}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <img
                                                className="rounded rounded-circle avatar-lg"
                                                width={150}
                                                src={setAvatar()}
                                                alt={user.firstName}
                                            />
                                        </Col>
                                        {!isEmpty(avatars) && (
                                            <Col>
                                                {avatars.map((item) => (
                                                    <img
                                                        className="rounded rounded-circle avatar-sm"
                                                        style={{
                                                            marginRight: '2px',
                                                            marginTop: '2px',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={(e) => updateAvatar(e, item)}
                                                        width={75}
                                                        src={item.iconUrl}
                                                        alt={item.id}
                                                    />
                                                ))}
                                            </Col>
                                        )}
                                    </Row>

                                    <br /><br />

                                    <FormGroup>
                                        <Label>Actualiza tu Avatar</Label>

                                        <Input type="file"
                                            id="image"
                                            onChange={ _handleFileUpload }
                                        />
                                    </FormGroup>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col sm={9}>
                            <Card>
                                <CardBody>
                                    <CardTitle>Administra tu información Personal</CardTitle>

                                    <Form id="create" method="POST" onSubmit={ _handleSubmit }>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Nombre/s *
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        value={user.firstName}
                                                        onChange={event => setUser({
                                                            ...user,
                                                            firstName: event.target.value
                                                        })}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Apellido/s *
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        value={user.lastName}
                                                        onChange={event => setUser({
                                                            ...user,
                                                            lastName: event.target.value
                                                        })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        E-Mail *
                                                    </Label>
                                                    <Input
                                                        type="email"
                                                        className="form-control"
                                                        value={user.email}
                                                        onChange={event => setUser({
                                                            ...user,
                                                            email: event.target.value
                                                        })}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={2}>
                                                <FormGroup>
                                                    <Label>
                                                        Código de País
                                                    </Label>
                                                    <select className="custom-select"
                                                        onChange={event => setUser({
                                                            ...user,
                                                            countryCode: event.target.value
                                                        })}
                                                        defaultValue={user.countryCode}>
                                                        {countryCodes.map((item, i) => {
                                                            let selected = user.countryCode === item.value ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item.value} selected={selected}>{item.label}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>

                                            <Col sm={4}>
                                                <FormGroup>
                                                    <Label>
                                                        Teléfono *
                                                    </Label>
                                                    <Input
                                                        type="tel"
                                                        className="form-control"
                                                        value={user.phone}
                                                        onChange={event => setUser({
                                                            ...user,
                                                            phone: event.target.value
                                                        })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        País
                                                    </Label>
                                                    <select className="custom-select"
                                                        onChange={event => setUser({
                                                            ...user,
                                                            country: event.target.value
                                                        })}
                                                        defaultValue={user.country}>
                                                        {countries.map((item, i) => {
                                                            let selected = user.country === item ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item} selected={selected}>{item}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>

                                            <Col sm={3}>
                                                <FormGroup>
                                                    <Label>
                                                        Tipo de Documento
                                                    </Label>
                                                    <select className="custom-select"
                                                        onChange={event => setUser({
                                                            ...user,
                                                            documentType: event.target.value
                                                        })}
                                                        defaultValue={user.documentType}>
                                                        {documentTypes.map((item, i) => {
                                                            let selected = user.documentType === item ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item} selected={selected}>{item}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={3}>
                                                <FormGroup>
                                                    <Label>
                                                        No. de Documento
                                                    </Label>
                                                    <Input
                                                        type="tel"
                                                        className="form-control"
                                                        value={user.document}
                                                        onChange={event => setUser({
                                                            ...user,
                                                            document: event.target.value
                                                        })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Sexo
                                                    </Label>
                                                    <select className="custom-select"
                                                        onChange={event => setUser({
                                                            ...user,
                                                            gender: event.target.value
                                                        })}
                                                        defaultValue={user.documentType}>
                                                        {genders.map((item, i) => {
                                                            let selected = user.gender === item ? 'selected' : ''
                                                            return (
                                                                <option key={i} value={item} selected={selected}>{item}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>Fecha de Nacimiento</Label>

                                                    <InputGroup>
                                                        <DatePicker
                                                            locale="es"
                                                            selected={dateOfBirth}
                                                            className="form-control"
                                                            dateFormat="dd/MM/yyyy"
                                                            onChange={date => setDateOfBirth(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                        />
												    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={12} style={{textAlign: 'right'}}>
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                                >
                                                    <i className={`mdi mdi-check`}></i> Actualizar mis datos
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>

                            <Card>
                                <CardBody>
                                    <CardTitle>Actualizar Contraseña</CardTitle>

                                    <Form id="create" method="POST" onSubmit={ _handleUdatePassword }>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Contraseña
                                                    </Label>
                                                    <Input
                                                        type="password"
                                                        className="form-control"
                                                        value={user.document}
                                                        onChange={event => setPassword(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={6}>
                                                <FormGroup>
                                                    <Label>
                                                        Confirmar Contraseña
                                                    </Label>
                                                    <Input
                                                        type="password"
                                                        className="form-control"
                                                        value={user.document}
                                                        onChange={event => setConfirmPassword(event.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={12} style={{textAlign: 'right'}}>
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                                >
                                                    <i className={`mdi mdi-check`}></i> Actualizar Contraseña
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                   </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return { user: state.Login.user }
}

export default connect(
    mapStatetoProps, { updateAvatar, updateProfile }
)(withRouter(withNamespaces()(Index)))
